/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="~/js/lib/lodash.js"/>

(function($, _) {
  var ns;

  ns = window.nspace("ccc.viz.shared.views");

  ns.SelectorsView = Backbone.View.extend({
    initialize: function(options) {
      this.validate(options);

      this.indicatorGroupId = options.indicatorGroupId;
      this.dispatcher = options.dispatcher;

      _.bindAll(this);

      this.model.on("change:indicatorId", this.render);

      // Initialize the various selectors
      this.initializeSelectors();

      // Initial render
      this.render();
      this.initializeView();
    },

    /**
     * Exposing an additional initialize method so that sub views can override if desired.
     */
    initializeView: function() {
      // no-op
    },

    validate: function(options) {
      if (!options.dispatcher) {
        throw "The selectors view requires an event dispatcher.";
      }
    },

    /**
     * Initialize selector views. Specific to each sub view.
     */
    initializeSelectors: function() {
      throw "Selectors must be initialized in sub views.";
    },

    /**
     * Returns selector info if we already have it stored locally. Throws an exception if we don't already
     * have it loaded. Seems like the least terrible solution for the fact that the Data Type selector needs to retrieve
     * selector info non-asynchronously within the "before-change" handler (If the handler isn't synchronous, then there's
     * no point in even having a "before-change" event.)
     */
    getSelectorInfoOrThrow: function() {
      if (!this.selectorInfo) {
        throw "Selector info has not yet been retrieved from the server.";
      }
      return this.selectorInfo;
    },

    getSelectorInfo: function(onSuccess) {
      var self = this;

      // Do we already have the response stored locally?
      if (this.selectorInfo) {
        setTimeout(function() {
          // Invoke the callback
          if (onSuccess) {
            onSuccess(self.selectorInfo);
          }
        }, 0);
        return;
      }

      // Otherwise, hit the web service
      this.trigger("busy");
      this.dispatcher.trigger("add-task", {
        name: "selectors-loading",
        text: "Loading selectors..."
      });
      $.ajax({
        url: this.options.selectorUrl || "/api/selectors/GetSelectorInfo",
        data: this.options.selectorData || {
          indicatorGroupId: this.indicatorGroupId
        },
        complete: function() {
          self.trigger("idle");
          self.dispatcher.trigger("end-task", { name: "selectors-loading" });
        },
        success: function(response) {
          // if there is no selected=true, select the first option
          function setDefaultIfMissing(items) {
            if (items && items.length) {
              var selectedItem = items.find(function(item) {
                return item.selected === true;
              });
              if (!selectedItem) {
                items[0].selected = true;
              }
            }
          }

          // are there ever more than 1 selector?? ¯\_(ツ)_/¯
          var id = Object.keys(response.selectors)[0];

          // make sure there is a selected characteristicId
          setDefaultIfMissing(response.selectors[id].characteristics);

          // make sure there is a selected locationType
          setDefaultIfMissing(response.selectors[id].locationTypes);

          // make sure there is a selected indicatorId
          // setDefaultIfMissing(response.indicators); do we need this?

          // Save for future use
          self.selectorInfo = response;
          self.model.selectorInfo = response;

          // Invoke the callback
          if (onSuccess) {
            onSuccess(response);
          }
        }
      });
    },

    getDataSummaryText: function(selectors, propertyNames) {
      var texts = [];
      $.each(selectors, function(i, selector) {
        var text = selector.getDataSummaryText();
        if (
          !_.str.isBlank(text) &&
          (!propertyNames ||
            _.indexOf(propertyNames, selector.propertyName) > -1)
        ) {
          texts.push(text);
        }
      });

      return texts.join("; ");
    },

    getDataSummary: function() {
      return this.getDataSummaryText(this.allSelectors);
    },

    getDataSummaryByPropertyNames: function(names) {
      return this.getDataSummaryText(this.allSelectors, names);
    },
    /**
     * Gets the list of selectors specific to indicators.
     */
    getIndicatorSpecificSelectors: function() {
      throw "Indicator specific selectors must be implemented in sub views.";
    },

    /**
     * Default implementation: override in sub classes.
     */
    renderSelectors: function(selectorInfo) {
      var indicatorSpecificSelectors, indicatorSelectorInfo;

      // Selectors that are specific to a single indicator. This is all selectors
      // besides the breakdown selector.
      indicatorSpecificSelectors = this.getIndicatorSpecificSelectors();

      // Breakdown selector
      this.breakdownSelectorView.render(selectorInfo);

      // The other selectors all expect indicator-specific selector info
      indicatorSelectorInfo =
        selectorInfo.selectors[this.model.get("indicatorId")];
      for (var i = 0; i < indicatorSpecificSelectors.length; i++) {
        // Render the selector
        indicatorSpecificSelectors[i].render(indicatorSelectorInfo);
      }
    },

    render: function() {
      var self = this;

      // Operate synchronously if we have selectorInfo available already. (Otherwise the data summary update happens before the selectors update, which can lead to an incorrect data summary.)
      if (this.selectorInfo) {
        this.renderSelectors(this.selectorInfo);
      }
      else {
        this.getSelectorInfo(function(selectorInfo) {
          self.renderSelectors(selectorInfo);
        });
      }
    }
  });
})(jQuery, _);
